<style xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    .bottom_btn_custom{
        display: inline;
        padding-right: 0px;
        padding-left: 0px;
    }
    .title_body {
        padding:0px;
    }
    .form-control {
        min-width: 147px;
    }

    .registClass {
        color : #321FDB;
    }
    /* 기초 CSS 디자인 */
    * {
        box-sizing:border-box;
    }
    body {
        margin:0;
    }
    .hidden {
        display:none;
        visibility:hidden;
    }

    /* 버튼으로 사용할 라벨 디자인 */
    .button {
        font-size:19px;
        font-weight:600;
        vertical-align:middle;
        cursor:pointer;
    }

    /* 모달 윈도우 디자인 */
    .box_modal {
        position: fixed;
        display: block;
    /*    width: 333px;
        height: 234px;*/
        top:50%;
        left:50%;
        margin-top:-75px;
        margin-left:-150px;
        background:#d9e5e9;
        border:1px solid #386980;
        overflow:hidden;
        /* 아래 부분은 애니메이션 효과를 위한 부분 */
        visibility: collapse;
        filter: alpha(opacity=60);
        -webkit-transition: all .2s ease;
        transition: all .2s ease;
        -webkit-transform: scale(0, 0);
        -ms-transform: scale(0, 0);
        transform: scale(0, 0);
    }
    .box_modal:hover {
        opacity: 1;
        filter: alpha(opacity=100);
    }

    /* 닫기 버튼으로 사용할 라벨 */
    .closer {
        position:absolute;
        width:30px;
        height:30px;
        top:0;
        right:0;
        background:#eee;
        border-left:1px solid #386980;
        border-bottom:1px solid #386980;
        text-align:center;
        line-height:26px;
        font-size:16x;
        cursor:pointer;
    }
    .text {
        display:inline-block;
        padding:20px;
    }
    .text h3 {
        font-size:19px;
        margin:0;
    }
    .text p {
        font-size:13px;
    }

    /* 모달 윈도우가 팝업되는 코어 소스 */
    input#modal[type=checkbox]:checked ~ .box_modal {
        visibility: visible;
        -webkit-transform: scale(1, 1);
        -ms-transform: scale(1, 1);
        transform: scale(1, 1);
        z-index: 10;
    }
    .textAreaCustom {
        line-height: 4.8;
    }


</style>
<template>
    <div>
        <form style="width: 100%" @submit.prevent="submit">
            <CCard>
                <CCardHeader>
                    <CIcon name="cil-justify-center"/> <strong> 실버노트 </strong>
                    <small></small>
                </CCardHeader>
                <CCardBody class="title_body" >
                    <CNavbar light color="light">
                        <CForm inline>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-9 input-group-sm">
                                    <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="startMonthVal" min="2000-01-02" max="2999-12-31" >
                                </div>
                            </div>
                            <div role="group" class="form-group form-row" style="margin-right: 10px;">
                                <div class="col-sm-9 input-group-sm">
                                    <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="endMonthVal" min="2000-01-02" max="2999-12-31" >
                                </div>
                            </div>
                            <div role="group" class="form-group form-row">
                                <div class="col-sm-9 input-group-sm">
                                    <CInput
                                            class="mr-sm-2"
                                            placeholder="이름 또는 진료번호"
                                            size="sm"
                                            v-model="searchVal"
                                            @keyup.enter="searchList"
                                    />
                                </div>
                            </div>
                            <CButton color="outline-success" size="sm" class="my-2 my-sm-0" type="button" @click="searchList" >검색</CButton>
                        </CForm>
                    </CNavbar>
                </CCardBody>
            </CCard>
        </form>
        <CRow>
            <div class="col-sm-12" style="margin-bottom: 10px;">
                <div class="col-sm-0.5">
                    <li class="bottom_btn_custom">
                        <div class="d-inline-block dropdown">
                            <select id="uid-utosbj1koo"  v-model="selectOption"  @change="selectPerPage" class="form-control">
                                <option value="10" selected>10개씩보기</option>
                                <option value="20">20개씩보기</option>
                                <option value="I50">50개씩보기</option>
                            </select>
                        </div>
                    </li>
                </div>
            </div>
            <!--   <div class="col-sm-9">
                   <select id="uid-utosbj1koo" style="width: 200px;"  v-model="selectOption" @change="selectPerPage"  class="col-sm-9 input-group-sm">
                       <option value="10" selected>10개씩보기</option>
                       <option value="20">20개씩보기</option>
                       <option value="I50">50개씩보기</option>
                   </select>
                   <small class="form-text text-muted w-100"></small>
               </div>-->
        </CRow>
        <CRow>
            <CCol sm="12">
                <div bordered="true" small="true">
                    <div class="position-relative table-responsive">
                        <b-table
                                id = "list-table"
                                :items="newItems"
                                :fields="fields"
                                :per-page="perPage"
                                :current-page="currentPage"
                                striped hover
                                @row-clicked="goUpdatePage"
                        >
                            <template v-slot:cell(check)="data">
                                <!--<CInputCheckbox v-on:click="check(data.item.custId)" >{{data.item.id}}</CInputCheckbox>-->
                                <b-form-group style="margin-bottom: 0px;">
                                    <input type="checkbox" v-model="data.item.check" />
                                </b-form-group>
                                <!--<input id="uid-0uvqn17l7g6g" type="checkbox" v-model="check" class="form-check-input" value="{{data.item.id}}">-->
                            </template>
                            <template v-slot:cell(id)="data">
                                <b  class="text-right">{{data.item.id}}</b>
                            </template>

                            <template v-slot:cell(charge)="data">
                                <div  class="text-right">{{data.item.charge }}</div>
                            </template>
                        </b-table>
                    </div>
                    <div style="float:right;">   </div>
                    <b-pagination
                            :link-gen="linkGen"
                            :number-of-pages="10"
                            use-router
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="list-table"
                    />
                </div>
            </CCol>
        </CRow>
        <div class="col-sm-0.5" style="padding-top: 10px;">
        <!--    <li class="bottom_btn_custom"><CDropdown
                    toggler-text="환자 등록"
                    color="primary"
                    class="d-inline-block"
            >
                <CDropdownItem @click="goCustInsert">건별 등록</CDropdownItem>
                <CDropdownItem @click="goExcelUpload">일괄 등록</CDropdownItem>
            </CDropdown></li>-->
            <li class="bottom_btn_custom">
                <CButton label=""
                         type="button"
                         style="margin:0;padding: 0;"
                         color="primary"
                         class="d-inline-block" @click="handle_toggle">
                    <label for="modal" @click="handle_toggle" style="margin-bottom: 0; padding: 6px 12px; cursor: pointer;">일괄적용</label>
                </CButton>
            </li>
            <!--<li class="bottom_btn_custom" style="margin-left: 10px">
                <CButton label=""
                          type="button"
                          style="text-align: right"
                          class="btn btn-info " @click="insertCharge">차감액 등록
                </CButton>
            </li>-->

            <input type="checkbox" id="modal" class="hidden" style="width: 333px;height: 234px;">
            <div class="box_modal"  style="  width: 333px;height: 234px;">
                <label for="modal" class="closer">x</label>
                <div class="text">

                    <h3>상태 일괄적용 <small style="font-size: 11px;"> (체크된 리스트에 적용됩니다.)</small></h3>
                    <p><br>
                 <!--   <div role="group" class="form-group form-row">
                        <label for="uid-rw1ppxoxk3h" class="col-form-label col-sm-3"> 건강상태 </label>
                        <div class="col-sm-9">
                            <div class="input-group">
                                <div class="col-md-12 col-form-label">
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio1">상</label>
                                        <input class="form-check-input" id="inline-radio1" type="radio" value="3" v-model="healthRadio">
                                    </div>
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio2">중</label>
                                        <input class="form-check-input" id="inline-radio2" type="radio" value="2" v-model="healthRadio">
                                    </div>
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio3">하</label>
                                        <input class="form-check-input" id="inline-radio3" type="radio" value="1" v-model="healthRadio">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <div role="group" class="form-group form-row">
                        <label for="uid-rw1ppxoxk3h" class="col-form-label col-sm-3"> 대변상태 </label>
                        <div class="col-sm-9">
                            <div class="input-group">
                                <div class="col-md-12 col-form-label">
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio1">상</label>
                                        <input class="form-check-input" id="inline-radio1" type="radio" value="3" v-model="item2">
                                    </div>
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio2">중</label>
                                        <input class="form-check-input" id="inline-radio2" type="radio" value="2" v-model="item2">
                                    </div>
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio3">하</label>
                                        <input class="form-check-input" id="inline-radio3" type="radio" value="1" v-model="item2">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div role="group" class="form-group form-row">
                        <label for="uid-rw1ppxoxk3h" class="col-form-label col-sm-3"> 식사량 </label>
                        <div class="col-sm-9">
                            <div class="input-group">
                                <div class="col-md-12 col-form-label">
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio1">상</label>
                                        <input class="form-check-input" id="inline-radio1" type="radio" value="3" v-model="item1">
                                    </div>
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio2">중</label>
                                        <input class="form-check-input" id="inline-radio2" type="radio" value="2" v-model="item1">
                                    </div>
                                    <div class="form-check form-check-inline mr-1">
                                        <label class="form-check-label" for="inline-radio3">하</label>
                                        <input class="form-check-input" id="inline-radio3" type="radio" value="1" v-model="item1">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CButton label=""
                             type="button"
                             style="text-align: center; margin:0; float: right;"
                             class="btn btn-info" @click="sendChkValue">
                        적용하기
                    </CButton>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
</style>
<script>
    import Vue from 'vue'
    import axios from "axios";
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment)

    export default {
        name: 'app',
        components: {},
        data: function () {
            return {
                isSelectedAll: false,
                items: [],
                item1:'2',
                item2:'2',
                selectOption :10,
                searchVal: null,
                Offline:[],
                monthVal: '',
                newItems: [],
                perPage: 10,
                currentPage: 1,
                chargeCnt:0,
                startMonthVal:  this.$moment().add(-1,'d') .format('YYYY-MM-DD'),
                endMonthVal: this.$moment().format('YYYY-MM-DD'),
                fields: [
                    {
                        key: 'check',
                        label: '',
                        class:"width_set_check"
                    },
                    {
                        key: 'id',
                        label: 'No',
                        class:"width_set_no",
                        sortable: true,
                    },
                    {
                        key: 'name',
                        label: '이름',
                        class:"width_set_nine",
                        sortable: true
                    },
                    {
                        key: 'registNo',
                        label: '진료번호',
                        class:"width_set_nine",
                        sortable: true
                    },
                    {
                        key: 'custStatus',
                        label: '상태',
                        class:"width_set_nine",
                        sortable: true
                    },
                    {
                        key: 'inDate',
                        label: '입원일',
                        class:"width_set_nine",
                        sortable: true
                    },
                    {
                        key: 'outDate',
                        label: '퇴원일',
                        class:"width_set_nine",
                        sortable: true
                    },
                    {
                        key: 'item1',
                        label: '대변상태',
                        labelAlign : 'right',
                        class:"width_set_nine",
                        sortable: true
                    },
                    {
                        key: 'item2',
                        label: '식사량',
                        class:"width_set_nine",
                        labelAlign : 'right',
                        sortable: true
                    },
                    {
                        key: 'memo',
                        label: '비고',
                        labelAlign : 'right',
                        sortable: true
                    }
                ],
                items: null,
                searchVal: null,
                custStatus: 'All',
                chargeStatus: 'All',
                paymentCompCnt: 0,
                paymentMissCnt: 0,
                totalMissAmount: 0,
                paymentMiss: "0",
                is_show: false,
                title:'',
                msg:''
            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        computed: {
            rows() {
                return this.newItems.length;
            }
        },
        mounted() {
            this.searchList();
            this.newItems.forEach(function(obj){
                if(obj.chargeStatus ==="미납"){
                    obj._rowVariant = "success";
                }
            });

        },
        methods: {
            handle_toggle: function(){
                this.is_show = !this.is_show; // #2, #3
            },
            searchList(value){
                const qs = require('qs');
                const formData = qs.stringify({'startMonthVal': this.startMonthVal, 'endMonthVal':this.endMonthVal, 'searchVal': this.searchVal})

                axios.post('silver/silverNote/getWellnessList', formData)
                    .then(res => {
                        this.newItems=[]
                        console.log("===================");
                        console.log(res.data);
                        console.log("===================");
                        this.items = res.data;
                        for(var i = 0; i < this.items.length; i++){
                            const obj = new Object();
                            if(this.items[i].custStatus === "I"){
                                obj.custStatus = "입원";
                            } else {
                                obj.custStatus = "퇴원";
                            }


                            obj.id = this.items.length - i;
                            obj.custId = this.items[i].custId;
                            //obj.id =this.items[i].id;
                            obj.name = this.items[i].name;
                            obj.registNo = this.items[i].registNo;
                            obj.check = false;
                            obj.checkDate = this.items[i].checkDate;

                            if(this.items[i].inDate === null || this.items[i].inDate === ""){
                                obj.inDate = "";
                            }else {
                                obj.inDate = this.$moment(this.items[i].inDate).format('YYYY-MM-DD');
                            }

                            if(this.items[i].outDate === null || this.items[i].outDate === ""){
                                obj.outDate = "";
                            }else {
                                obj.outDate = this.$moment(this.items[i].outDate).format('YYYY-MM-DD');
                            }

                            if(this.items[i].item1 == 1){
                                obj.item1 = "적음";
                            }else if (this.items[i].item1 == 2){
                                obj.item1 = "보통";
                            }else if (this.items[i].item1 == 3){
                                obj.item1 = "많음";
                            }

                            if(this.items[i].item2 == 1){
                                obj.item2 = "나쁨";
                            }else if (this.items[i].item2 == 2){
                                obj.item2 = "보통";
                            }else if (this.items[i].item2 == 3){
                                obj.item2 = "좋음";
                            }

                            obj.memo = this.items[i].memo;

                            this.newItems.push(obj);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                axios.post('silver/charge/getChargeListCnt', formData)
                    .then(res => {
                        this.chargeCnt = res.data.chargeCnt;
                        this.totalChargeAmount = res.data.totalChargeAmount;
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            /*  allCount(){
                  axios.post('silver/cust/getCustListCnt',{'searchVal': this.searchVal
                      ,'custStatus': this.custStatus
                      ,'chargeStatus': this.chargeStatus
                  })
                      .then(res => {

                          console.log(res.data)
                          this.paymentCompCnt = res.data.paymentCompCnt ,
                          this.paymentMissCnt = res.data.paymentMissCnt,
                          this.totalMissAmount = res.data.totalMissAmount
                      })
                      .catch(function(error) {
                          console.log(error);
                      });
              },*/

            goCustInsert() {
                this.$router.push({name: 'paymanageinsert'});
            },

            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            goExcelUpload(){
                this.$router.push({name: 'excelupload'});
            },

            linkGen(pageNum) {
                return pageNum === 1 ? '?' : '?page=${pageNum}';
            },

            goUpdatePage(record, index) {
                this.$router.push({name: 'paymanageupdate', params: {custId: record.custId}});
            }
            , getFileName (contentDisposition) {
                let fileName = contentDisposition
                    .split(';')
                    .filter((ele) => {
                        return ele.toLowerCase().indexOf('filename') > -1
                    })
                    .map((ele) => {
                        return ele
                            .replace(/"/g, '')
                            .split('=')[1]
                    });
                return fileName[0] ? fileName[0] : null
            }
            , selectPerPage () {
                this.perPage =  this.selectOption;
            }
            , insertCharge() {
                this.$router.push({name: 'chargeRegist'});
            }
            , sendChkValue() {
                var ids = [];
                var checkDate = [];

                for(var i = 0; i < this.newItems.length; i++){
                    if(this.newItems[i].check == true){
                        ids.push(this.newItems[i].custId)
                        checkDate.push(this.newItems[i].checkDate)
                    }
                }
                if(ids.length > 0 ){


                var healthList = {'item1':this.item1, 'item2':this.item2 ,'checkDate':this.newItems.checkDate, 'ids':ids ,'checkDate':checkDate};
                console.log(healthList);
                axios.post('silver/cust/updateHealth', {'healthList' :healthList})
                    .then(res => {
                        alert("일괄 수정되었습니다.");
                        this.searchList();
                        document.getElementById('modal').click();

                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                }else {
                    alert("한개이상 체크해야합니다.");
                }
            }
        }
    }
</script>